import { render, staticRenderFns } from "./reciboPagamento.vue?vue&type=template&id=2026aa57&scoped=true&"
import script from "./reciboPagamento.vue?vue&type=script&lang=js&"
export * from "./reciboPagamento.vue?vue&type=script&lang=js&"
import style0 from "./reciboPagamento.vue?vue&type=style&index=0&id=2026aa57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026aa57",
  null
  
)

export default component.exports